module.exports = __webpack_public_path__ + "media/Audio19_h.d01e8fd3.wav";